function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { DefaultButton, Dialog, DialogFooter, Icon, Link, mergeStyleSets, PrimaryButton, Spinner, SpinnerSize, Stack, Text } from '@fluentui/react';
import * as PropTypes from 'prop-types';
import { Constants } from '@shared/utils/constants';
import { getReviewCommentsModalDialogProps, launchTelemetry } from '@shared/utils/reviewsUtils';
import { logger } from '@src/logger';
import { SharedColors } from '@fluentui/theme';
const ReviewCommentModalStyles = mergeStyleSets({
    infoIcon: {
        color: SharedColors.red20,
        fontSize: '16px'
    },
    loader: {
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2200
    }
});
export function ReviewCommentModal({ payload, onDeleteComment, onEditComment, dismissModal }, context) {
    const { modalMode: initialModalMode } = payload;
    const [modalMode, setModalMode] = useState(initialModalMode);
    useEffect(()=>{
        // Update the current modal mode state if the prop value changes
        setModalMode(initialModalMode);
    }, [
        initialModalMode
    ]);
    const dismissModalWithTelemetry = ()=>{
        launchTelemetry(Constants.Telemetry.Action.Close, Constants.Telemetry.ActionModifier.ReviewItemCommentDialog, {
            payload: payload.actionPayload
        });
        logger.info(JSON.stringify({
            payload: payload.actionPayload
        }), {
            action: Constants.Telemetry.Action.Close,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialog
        });
        dismissModal();
    };
    const onInnerDialogDelete = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*() {
            try {
                launchTelemetry(Constants.Telemetry.Action.Submitting, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete, {
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                });
                logger.info(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                }), {
                    action: Constants.Telemetry.Action.Submitting,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete
                });
                setModalMode(Constants.Reviews.ReviewCommentModalMode.Loading);
                const { offerId, reviewId, commentId, isNewlyAddedComment } = payload.actionPayload;
                yield onDeleteComment({
                    offerId,
                    reviewId,
                    commentId,
                    isNewlyAddedComment
                });
                dismissModalWithTelemetry();
                launchTelemetry(Constants.Telemetry.Action.Submitted, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete, {
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                });
                logger.info(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                }), {
                    action: Constants.Telemetry.Action.Submitted,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete
                });
            } catch (e) {
                var _payload_actionPayload, _payload_actionPayload1, _payload_actionPayload2, _payload_actionPayload3, _payload_actionPayload4, _payload_actionPayload5;
                setModalMode(Constants.Reviews.ReviewCommentModalMode.DeleteError);
                launchTelemetry(Constants.Telemetry.Action.SubmitError, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete, {
                    payload: payload.actionPayload,
                    commentId: (_payload_actionPayload = payload.actionPayload) === null || _payload_actionPayload === void 0 ? void 0 : _payload_actionPayload.commentId,
                    appId: (_payload_actionPayload1 = payload.actionPayload) === null || _payload_actionPayload1 === void 0 ? void 0 : _payload_actionPayload1.offerId,
                    reviewId: (_payload_actionPayload2 = payload.actionPayload) === null || _payload_actionPayload2 === void 0 ? void 0 : _payload_actionPayload2.reviewId,
                    error: `Failed deleting a review comment from the review comment modal, error: ${e}`
                });
                logger.error(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: (_payload_actionPayload3 = payload.actionPayload) === null || _payload_actionPayload3 === void 0 ? void 0 : _payload_actionPayload3.commentId,
                    appId: (_payload_actionPayload4 = payload.actionPayload) === null || _payload_actionPayload4 === void 0 ? void 0 : _payload_actionPayload4.offerId,
                    reviewId: (_payload_actionPayload5 = payload.actionPayload) === null || _payload_actionPayload5 === void 0 ? void 0 : _payload_actionPayload5.reviewId,
                    error: `Failed deleting a review comment from the review comment modal, error: ${e}`
                }), {
                    action: Constants.Telemetry.Action.SubmitError,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogDelete
                });
            }
        });
        return function onInnerDialogDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    const onInnerDialogUpdate = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*() {
            try {
                launchTelemetry(Constants.Telemetry.Action.Submitting, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate, {
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                });
                logger.info(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                }), {
                    action: Constants.Telemetry.Action.Submitting,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate
                });
                setModalMode(Constants.Reviews.ReviewCommentModalMode.Loading);
                const { offerId, reviewId, commentId, commentContent, isNewlyAddedComment } = payload.actionPayload;
                yield onEditComment({
                    offerId,
                    reviewId,
                    commentId,
                    commentContent,
                    isNewlyAddedComment
                });
                dismissModalWithTelemetry();
                launchTelemetry(Constants.Telemetry.Action.Submitted, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate, {
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                });
                logger.info(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: payload.actionPayload.commentId,
                    appId: payload.actionPayload.offerId,
                    reviewId: payload.actionPayload.reviewId
                }), {
                    action: Constants.Telemetry.Action.Submitted,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate
                });
            } catch (e) {
                var _payload_actionPayload, _payload_actionPayload1, _payload_actionPayload2, _payload_actionPayload3, _payload_actionPayload4, _payload_actionPayload5;
                setModalMode(Constants.Reviews.ReviewCommentModalMode.UpdateError);
                launchTelemetry(Constants.Telemetry.Action.SubmitError, Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate, {
                    payload: payload.actionPayload,
                    commentId: (_payload_actionPayload = payload.actionPayload) === null || _payload_actionPayload === void 0 ? void 0 : _payload_actionPayload.commentId,
                    appId: (_payload_actionPayload1 = payload.actionPayload) === null || _payload_actionPayload1 === void 0 ? void 0 : _payload_actionPayload1.offerId,
                    reviewId: (_payload_actionPayload2 = payload.actionPayload) === null || _payload_actionPayload2 === void 0 ? void 0 : _payload_actionPayload2.reviewId,
                    error: `Failed updating a review comment from the review comment modal, error: ${e}`
                });
                logger.error(JSON.stringify({
                    payload: payload.actionPayload,
                    commentId: (_payload_actionPayload3 = payload.actionPayload) === null || _payload_actionPayload3 === void 0 ? void 0 : _payload_actionPayload3.commentId,
                    appId: (_payload_actionPayload4 = payload.actionPayload) === null || _payload_actionPayload4 === void 0 ? void 0 : _payload_actionPayload4.offerId,
                    reviewId: (_payload_actionPayload5 = payload.actionPayload) === null || _payload_actionPayload5 === void 0 ? void 0 : _payload_actionPayload5.reviewId,
                    error: `Failed updating a review comment from the review comment modal, error: ${e}`
                }), {
                    action: Constants.Telemetry.Action.SubmitError,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentDialogUpdate
                });
            }
        });
        return function onInnerDialogUpdate() {
            return _ref.apply(this, arguments);
        };
    }();
    const innerDialogProps = {
        onDelete: onInnerDialogDelete,
        onUpdate: onInnerDialogUpdate,
        dismissModal: dismissModalWithTelemetry,
        context,
        payload
    };
    switch(modalMode){
        case Constants.Reviews.ReviewCommentModalMode.ConfirmUpdate:
            return /*#__PURE__*/ _jsx(ReviewCommentModalConfirmUpdateDialog, _object_spread({}, innerDialogProps));
        case Constants.Reviews.ReviewCommentModalMode.ConfirmDelete:
            return /*#__PURE__*/ _jsx(ReviewCommentModalConfirmDeleteDialog, _object_spread({}, innerDialogProps));
        case Constants.Reviews.ReviewCommentModalMode.UpdateError:
            return /*#__PURE__*/ _jsx(ReviewCommentModalUpdateErrorDialog, _object_spread({}, innerDialogProps));
        case Constants.Reviews.ReviewCommentModalMode.DeleteError:
            return /*#__PURE__*/ _jsx(ReviewCommentModalDeleteErrorDialog, _object_spread({}, innerDialogProps));
        case Constants.Reviews.ReviewCommentModalMode.ContentViolation:
            return /*#__PURE__*/ _jsx(ReviewCommentModalContentViolationDialog, _object_spread({}, innerDialogProps));
        case Constants.Reviews.ReviewCommentModalMode.CreateError:
            return /*#__PURE__*/ _jsx(ReviewCommentModalCreateErrorDialog, _object_spread({}, innerDialogProps));
        default:
            return /*#__PURE__*/ _jsx(Spinner, {
                className: ReviewCommentModalStyles.loader,
                size: SpinnerSize.large,
                label: context.loc('AppDetail_LoadingText', 'Loading...'),
                ariaLive: "assertive"
            });
    }
}
ReviewCommentModal.contextTypes = {
    loc: PropTypes.func
};
export function ReviewCommentModalConfirmUpdateDialog({ context, onUpdate, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_ConfirmUpdate_Title', 'Update your comment?'));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                children: context.loc('ReviewCommentActionModal_ConfirmUpdate_Description', 'Your comment will be updated.')
            }),
            /*#__PURE__*/ _jsxs(DialogFooter, {
                children: [
                    /*#__PURE__*/ _jsx(PrimaryButton, {
                        onClick: onUpdate,
                        text: context.loc('ReviewCommentActionModal_ConfirmUpdate_Submit_Button_Label', 'Update')
                    }),
                    /*#__PURE__*/ _jsx(DefaultButton, {
                        onClick: dismissModal,
                        text: context.loc('ReviewCommentActionModal_ConfirmUpdate_Cancel_Button_Label', 'Discard')
                    })
                ]
            })
        ]
    });
}
export function ReviewCommentModalConfirmDeleteDialog({ context, onDelete, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_ConfirmDelete_Title', 'Delete your comment?'));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsx(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                verticalAlign: "center",
                children: /*#__PURE__*/ _jsx(Text, {
                    children: context.loc('ReviewCommentActionModal_ConfirmDelete_Description', "It won't appear in the reviews feed and won’t be available any longer.")
                })
            }),
            /*#__PURE__*/ _jsxs(DialogFooter, {
                children: [
                    /*#__PURE__*/ _jsx(PrimaryButton, {
                        onClick: onDelete,
                        text: context.loc('ReviewCommentActionModal_ConfirmDelete_Submit_Button_Label', 'Delete')
                    }),
                    /*#__PURE__*/ _jsx(DefaultButton, {
                        onClick: dismissModal,
                        text: context.loc('ReviewCommentActionModal_ConfirmDelete_Cancel_Button_Label', 'Cancel')
                    })
                ]
            })
        ]
    });
}
export function ReviewCommentModalUpdateErrorDialog({ context, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_UpdateError_Title', "Couldn't update your comment"));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        className: ReviewCommentModalStyles.infoIcon
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('ReviewCommentActionModal_UpdateError_Description', 'There was a problem updating your comment. Please try again.')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: dismissModal,
                    text: context.loc('ReviewCommentActionModal_UpdateError_Cancel_Button_Label', 'Close')
                })
            })
        ]
    });
}
export function ReviewCommentModalDeleteErrorDialog({ context, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_DeleteError_Title', "Couldn't delete your comment"));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        className: ReviewCommentModalStyles.infoIcon
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('ReviewCommentActionModal_DeleteError_Description', 'There was a problem deleting your comment. Please try again.')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: dismissModal,
                    text: context.loc('ReviewCommentActionModal_DeleteError_Cancel_Button_Label', 'Close')
                })
            })
        ]
    });
}
export function ReviewCommentModalContentViolationDialog({ context, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_ContentViolation_Title', "Your comment wasn't published"));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        className: ReviewCommentModalStyles.infoIcon
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        children: [
                            context.loc('ReviewCommentActionModal_ContentViolation_Description', "We couldn't publish your comment because we detected some offensive content which violates Microsoft terms."),
                            ' ',
                            /*#__PURE__*/ _jsx(Link, {
                                target: "_blank",
                                href: Constants.MicrosoftRatingReviewPolicy,
                                children: context.loc('ReviewCommentActionModal_ContentViolation_Policy_Link_Label', 'View Microsoft AppSource review policies')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: dismissModal,
                    text: context.loc('ReviewCommentActionModal_ContentViolation_Cancel_Button_Label', 'Close')
                })
            })
        ]
    });
}
export function ReviewCommentModalCreateErrorDialog({ context, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewCommentActionModal_CreateError_Title', "Couldn't publish your comment"));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        className: ReviewCommentModalStyles.infoIcon
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('ReviewCommentActionModal_CreateError_Description', 'There was a problem publishing your comment. Please try again.')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: dismissModal,
                    text: context.loc('ReviewCommentActionModal_CreateError_Cancel_Button_Label', 'Close')
                })
            })
        ]
    });
}
